<template>
  <v-container>
    <v-row v-if="service" align="center" justify="center">
      <v-col v-if="!sended" cols="12" sm="10" md="8">
        <v-card hover class="mb-4">
          <v-system-bar color="teal darken-4" dark>
            <h3 class="teal--text text--lighten-5">Primeros platos</h3>
          </v-system-bar>
          <v-card-text>
            <div
              v-for="(recipe, index) in service.recipes.first"
              class="student-valoration"
              v-if="first.i === index || first.i === null"
            >
              <h3 class="plate-header">{{ recipe.name }}</h3>
              <v-rating
                v-if="first.comment"
                class="stars"
                half-increments
                dense
                color="teal darken-2"
                background-color="teal darken-2"
                v-model="first.rating"
                :readonly="first.i !== index"
              ></v-rating>
              <v-card-text>
                <v-form>
                  <v-textarea
                    label="Comentario"
                    auto-grow
                    filled
                    color="teal darken-2"
                    rows="1"
                    counter="200"
                    maxlength="200"
                    v-model="first.comment"
                    placeholder="Escribe un comentario para poder valorar el plato"
                    @keyup="
                      first.id = recipe.id;
                      first.i = index;
                      first.name = recipe.name;
                    "
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              text
              @click="first = { i: null, id: null, rating: 0, comment: '' }"
              >Reiniciar</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card hover class="mb-4">
          <v-system-bar color="teal darken-4" dark>
            <h3 class="teal--text text--lighten-5">Segundos platos</h3>
          </v-system-bar>
          <v-card-text>
            <div
              v-for="(recipe, index) in service.recipes.second"
              class="student-valoration"
              v-if="second.i === index || second.i === null"
            >
              <h3>{{ recipe.name }}</h3>
              <v-rating
                v-if="second.comment"
                class="stars"
                half-increments
                dense
                color="teal darken-2"
                background-color="teal darken-2"
                v-model="second.rating"
                :readonly="second.i !== index"
              ></v-rating>
              <v-card-text>
                <v-form>
                  <v-textarea
                    label="Comentario"
                    auto-grow
                    filled
                    color="teal darken-2"
                    rows="1"
                    counter="200"
                    maxlength="200"
                    v-model="second.comment"
                    placeholder="Escribe un comentario para poder valorar el plato"
                    @keyup="
                      second.id = recipe.id;
                      second.i = index;
                      second.name = recipe.name;
                    "
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              text
              @click="second = { i: null, id: null, rating: 0, comment: '' }"
              >Reiniciar</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card hover class="mb-4">
          <v-system-bar color="teal darken-4" dark>
            <h3 class="teal--text text--lighten-5">Postres</h3>
          </v-system-bar>
          <v-card-text>
            <div
              v-for="(recipe, index) in service.recipes.desert"
              class="student-valoration"
              v-if="desert.i === index || desert.i === null"
            >
              <h3>{{ recipe.name }}</h3>
              <v-rating
                v-if="desert.comment"
                class="stars"
                half-increments
                dense
                color="teal darken-2"
                background-color="teal darken-2"
                v-model="desert.rating"
                :readonly="desert.i !== index"
              ></v-rating>
              <v-card-text>
                <v-form>
                  <v-textarea
                    label="Comentario"
                    auto-grow
                    filled
                    color="teal darken-2"
                    rows="1"
                    counter="200"
                    maxlength="200"
                    v-model="desert.comment"
                    placeholder="Escribe un comentario para poder valorar el plato"
                    @keyup="
                      desert.id = recipe.id;
                      desert.i = index;
                      desert.name = recipe.name;
                    "
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              text
              @click="desert = { i: null, id: null, rating: 0, comment: '' }"
              >Reiniciar</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card hover class="mb-4">
          <v-system-bar color="teal darken-4" dark>
            <h3 class="teal--text text--lighten-5">Guarnición</h3>
          </v-system-bar>
          <v-card-text>
            <div
              v-for="(recipe, index) in service.recipes.garnish || []"
              class="student-valoration"
              v-if="garnish.i === index || garnish.i === null"
            >
              <h3>{{ recipe.name }}</h3>
              <v-rating
                v-if="garnish.comment"
                class="stars"
                half-increments
                dense
                color="teal darken-2"
                background-color="teal darken-2"
                v-model="garnish.rating"
                :readonly="garnish.i !== index"
              ></v-rating>
              <v-card-text>
                <v-form>
                  <v-textarea
                    label="Comentario"
                    auto-grow
                    filled
                    color="teal darken-2"
                    rows="1"
                    counter="200"
                    maxlength="200"
                    v-model="garnish.comment"
                    placeholder="Escribe un comentario para poder valorar el plato"
                    @keyup="
                      garnish.id = recipe.id;
                      garnish.i = index;
                      garnish.name = recipe.name;
                    "
                  ></v-textarea>
                </v-form>
              </v-card-text>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              text
              @click="garnish = { i: null, id: null, rating: 0, comment: '' }"
              >Reiniciar</v-btn
            >
          </v-card-actions>
        </v-card>

        <br />
        <div class="button-frame">
          <v-btn
            v-if="
              first.i !== null &&
              first.rating !== 0 &&
              second.i !== null &&
              second.rating !== 0 &&
              desert.i !== null &&
              desert.rating !== 0
            "
            align="center"
            text
            @click="sendPoll"
            >Enviar</v-btn
          >
        </div>
        <div
          v-if="
            !(
              first.i !== null &&
              first.rating !== 0 &&
              second.i !== null &&
              second.rating !== 0 &&
              desert.i !== null &&
              desert.rating !== 0
            )
          "
          class="send-warning"
        >
          Para poder enviar la encuesta necesitas valorar y comentar todos los
          platos.
        </div>
      </v-col>
      <v-col v-if="sended" class="thanks">
        <p>Tu encuesta se ha enviado</p>
        <br />
        <p>Tu opinión es importante para nosotros, ¡gracias por participar!</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase";

export default {
  props: { code: String },
  name: "poll",
  data() {
    return {
      sended: false,
      first: {
        i: null,
        label: "Primer plato",
        name: null,
        id: null,
        rating: 0,
        comment: "",
      },
      second: {
        i: null,
        label: "Segundo plato",
        name: null,
        id: null,
        rating: 0,
        comment: "",
      },
      desert: {
        i: null,
        label: "Postre",
        name: null,
        id: null,
        rating: 0,
        comment: "",
      },
      garnish: {
        i: null,
        label: "Guarnición",
        name: null,
        id: null,
        rating: 0,
        comment: "",
      },
      service: null,
    };
  },
  created: function () {
    firebase
      .firestore()
      .collection("services")
      .where("code", "==", this.code)
      .get()
      .then((refs) => {
        this.service = refs.docs[0].data();
      });
  },
  methods: {
    sendPoll: function () {
      this.sended = true;
      let comment = {
        rating:
          (this.first.rating +
            this.second.rating +
            this.desert.rating +
            this.garnish.rating) /
          4,
        content: [this.first, this.second, this.desert, this.garnish],
        sign:
          "Un alumno de " +
          this.service.group.split(": ")[1] +
          " de " +
          this.service.group.split(": ")[0],
      };
      let serviceRef = firebase
        .firestore()
        .collection("services")
        .doc(this.service.id);
      serviceRef.get().then((ref) => {
        let service = ref.data();
        let rating =
          (service.comments.length * service.rating + comment.rating) /
          (service.comments.length + 1);

        let recipes = service.recipes;
        console.log("RECIPES", recipes);

        if (recipes.first.length > 0) {
          recipes.first[comment.content[0].i].rating =
            (service.recipes.first[comment.content[0].i].comments *
              service.recipes.first[comment.content[0].i].rating +
              comment.content[0].rating) /
            (service.recipes.first[comment.content[0].i].comments + 1);

          recipes.first[comment.content[0].i].comments =
            service.recipes.first[comment.content[0].i].comments + 1;
        }

        if (recipes.second.length > 0) {
          recipes.second[comment.content[1].i].rating =
            (service.recipes.second[comment.content[1].i].comments *
              service.recipes.second[comment.content[1].i].rating +
              comment.content[1].rating) /
            (service.recipes.second[comment.content[1].i].comments + 1);

          recipes.second[comment.content[1].i].comments =
            service.recipes.second[comment.content[1].i].comments + 1;
        }

        if (recipes.desert.length > 0) {
          recipes.desert[comment.content[2].i].rating =
            (service.recipes.desert[comment.content[2].i].comments *
              service.recipes.desert[comment.content[2].i].rating +
              comment.content[2].rating) /
            (service.recipes.desert[comment.content[2].i].comments + 1);

          recipes.desert[comment.content[2].i].comments =
            service.recipes.desert[comment.content[2].i].comments + 1;
        }

        if (recipes.garnish.length > 0) {
          recipes.garnish[comment.content[3].i].rating =
            (service.recipes.garnish[comment.content[3].i].comments *
              service.recipes.garnish[comment.content[3].i].rating +
              comment.content[3].rating) /
            (service.recipes.garnish[comment.content[3].i].comments + 1);

          recipes.garnish[comment.content[3].i].comments =
            service.recipes.garnish[comment.content[3].i].comments + 1;
        }

        serviceRef.update({
          recipes: recipes,
          comments: firebase.firestore.FieldValue.arrayUnion(comment),
          rating: rating,
        });
      });
      comment.content.forEach((recipe) => {
        console.log("RECIPE", recipe);
        if (recipe && recipe.id) {
          let recipeRef = firebase
            .firestore()
            .collection("recipes")
            .doc(recipe.id);
          recipeRef.get().then((ref) => {
            let rating = ref.data().rating;
            let nComments = ref.data().comments.length;
            let newRating =
              (rating * nComments + recipe.rating) / (nComments + 1);
            recipeRef.update({
              rating: newRating,
              comments: firebase.firestore.FieldValue.arrayUnion({
                date: this.service.date,
                rating: recipe.rating,
                comment: recipe.comment,
                sign:
                  "Un alumno de " +
                  this.service.group.split(": ")[1] +
                  " de " +
                  this.service.group.split(": ")[0],
              }),
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plate-type {
  display: inline-block;
  background-color: lightgrey;
  font-weight: bold;
  padding-left: 10px;
  width: 100%;
}
.student-valoration {
  h3 {
    display: inline-block;
    padding-left: 15px;
    width: fill;
  }
  .stars {
    padding-right: 10px;
    margin-top: -6px;
    display: inline-block;
    width: fill;
    text-align: right;
  }
}
.button-frame {
  text-align: center;
}
.thanks {
  margin-top: 100px;
  font-size: 1.4em;
  text-align: center;
}
.send-warning {
  display: block;
  border-radius: 5px;
  border: 2px solid red;
  text-align: center;
  font-weight: bold;
  padding: 10px;
  background-color: rgb(241, 197, 156);
}
</style>